import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import RichTextInput from 'common/components/richTextInput/RichTextInput';

interface Props {
    parameter: BudgetLineParameterDto;
    disabled: boolean;
    onChange: (parameter: Partial<BudgetLineParameterDto>, calculateTotals: boolean) => void;
}

function ParameterText({ parameter, disabled,onChange }: Props): JSX.Element | null {
    return (
        <RichTextInput
            value={parameter.text?.text ?? undefined}
            onBlur={(v) => onChange({ text: { text: v ?? '' } }, false)}
            disabled={disabled}
        />
    );
}

export default ParameterText;
